import { render, staticRenderFns } from "./UserDemoList.vue?vue&type=template&id=a3e7603a&scoped=true&"
import script from "./UserDemoList.vue?vue&type=script&lang=ts&"
export * from "./UserDemoList.vue?vue&type=script&lang=ts&"
import style0 from "./UserDemoList.vue?vue&type=style&index=0&id=a3e7603a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e7603a",
  null
  
)

export default component.exports